import { getSelectionConfig, DEFAULT_COLORS } from '@/components/widget/visualizations/StackedBarChart';
import CollectionOptionFields from '@/components/Editor/Form/fields/CollectionOption';
import { jsx as _jsx } from "react/jsx-runtime";
export function generateCollectionSettings(_ref) {
  var _config$globalSeriesO;

  let {
    config
  } = _ref;
  return {
    title: 'Category',
    selectionsLabeled: false,
    selectionConfig: getSelectionConfig('stacked'),
    defaults: {
      template: (_config$globalSeriesO = config.globalSeriesOptions) === null || _config$globalSeriesO === void 0 ? void 0 : _config$globalSeriesO.template
    }
  };
}

const WidgetEditFormStackedBarChartCollectionOption = _ref2 => {
  let {
    nameSpace,
    collectionIndex,
    collectionOption,
    exampleValue,
    colorPallet = DEFAULT_COLORS,
    defaults,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(CollectionOptionFields, {
    namePrefix: nameSpace,
    index: collectionIndex,
    config: collectionOption,
    exampleValue: exampleValue,
    singleLabel: false,
    colored: false,
    hasLabel: false,
    hasTrendline: false,
    hasDataLabels: true,
    defaultValues: {
      template: defaults === null || defaults === void 0 ? void 0 : defaults.template,
      color: colorPallet[collectionIndex]
    },
    onChange: onChange
  });
};

export default WidgetEditFormStackedBarChartCollectionOption;